/* eslint-disable react/forbid-prop-types */
import { Select } from '@tmov/design-system';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce/lib';

import { carregaCidades } from '../../../../helpers/cidades';
import { carregaEstadosBrasil } from '../../../../helpers/estados';
import { toTitleCase } from '../../../../helpers/formatador';
import { searchProdutosAts } from '../../../../helpers/produtos';
import { Container } from './styles';

const { RangePicker } = DatePicker;

const medidaOptions = [
  { id: 'peso_volume', value: 'Volume (ton)' },
  { id: 'valor_custo', value: 'Faturamento (R$)' },
  { id: 'quantidade_viagens', value: 'Quantidade de viagens' },
  { id: 'ticket_medio', value: 'Ticket Médio (R$/ton)' },
  { id: 'aderencia_cadencia', value: 'Aderência (%)' },
];

const Filters = ({ filters }) => {
  const [produtoSearch, setProdutoSearch] = useState('');
  const [produtoValues, setProdutoValues] = useState([]);
  const [produtoLoading, setProdutoLoading] = useState(false);
  const produtoOptions = useMemo(
    () =>
      produtoValues?.length > 0
        ? produtoValues.map(item => ({
            id: item.IdProduto,
            value: toTitleCase(item.Descricao),
          }))
        : [],
    [produtoValues]
  );
  const handleChangeProdutoSearch = useDebouncedCallback(searchValue => {
    setProdutoSearch(searchValue);
  }, 300);

  const [estadoValues, setEstadoValues] = useState([]);
  const [estadoLoading, setEstadoLoading] = useState(false);
  const estadoOptions = useMemo(
    () =>
      estadoValues?.length > 0
        ? estadoValues.map(item => ({
            id: item.IdEstado,
            value: toTitleCase(item.Nome),
          }))
        : [],
    [estadoValues]
  );

  const [cidadeSearch, setCidadeSearch] = useState('');
  const [cidadeValues, setCidadeValues] = useState([]);
  const [cidadeLoading, setCidadeLoading] = useState(false);
  const cidadeOptions = useMemo(
    () =>
      cidadeValues?.length > 0
        ? cidadeValues.map(item => ({
            id: item.idCidade,
            value: toTitleCase(item.cidadeNome),
          }))
        : [],
    [cidadeValues]
  );
  const handleChangeCidadeSearch = useDebouncedCallback(searchValue => {
    setCidadeSearch(searchValue);
  }, 300);

  useEffect(() => {
    const loadProdutoValues = async () => {
      await searchProdutosAts(
        produtoSearch,
        setProdutoValues,
        setProdutoLoading
      );
      setProdutoValues(prevState => [
        ...prevState,
        { IdProduto: 0, Descricao: 'Todos' },
      ]);
    };
    loadProdutoValues();
  }, [produtoSearch]);

  useEffect(() => {
    const loadCidades = async () => {
      await carregaCidades(cidadeSearch, setCidadeValues, setCidadeLoading);
      setCidadeValues(prevState => [
        ...prevState,
        { idCidade: 0, cidadeNome: 'Todas' },
      ]);
    };
    loadCidades();
  }, [cidadeSearch]);

  useEffect(() => {
    const loadEstados = async () => {
      await carregaEstadosBrasil(setEstadoValues, setEstadoLoading);
      setEstadoValues(prevState => [
        ...prevState,
        { IdEstado: 0, Nome: 'Todos' },
      ]);
    };
    loadEstados();
  }, []);

  return (
    <Container>
      <RangePicker
        value={filters.periodo}
        onChange={filters.handlePeriodo}
        data-testid="periodoInput"
        format="DD/MM/yyyy"
        style={{ height: 48 }}
        allowClear={false}
      />
      <Select
        label="Produto"
        options={produtoOptions}
        selectedOption={filters.produto}
        onChangeOption={filters.handleProduto}
        onChangeSearch={handleChangeProdutoSearch}
        isLoading={produtoLoading}
        noResultsText={
          produtoSearch.length < 3
            ? 'Insira pelo menos 3 caracteres para pesquisar'
            : 'Não há itens que correspondem à pesquisa'
        }
        allowClear={false}
      />
      <Select
        label="Cidade"
        options={cidadeOptions}
        selectedOption={filters.cidade}
        onChangeOption={filters.handleCidade}
        onChangeSearch={handleChangeCidadeSearch}
        isLoading={cidadeLoading}
        noResultsText={
          produtoSearch.length < 3
            ? 'Insira pelo menos 3 caracteres para pesquisar'
            : 'Não há itens que correspondem à pesquisa'
        }
        allowClear={false}
      />
      <Select
        label="Estado"
        isLoading={estadoLoading}
        options={estadoOptions}
        selectedOption={filters.estado}
        onChange={filters.handleEstado}
        allowClear={false}
      />
      <Select
        label="Medida"
        options={medidaOptions}
        selectedOption={filters.medida}
        onChangeOption={filters.handleMedida}
        allowClear={false}
      />
    </Container>
  );
};

Filters.propTypes = {
  filters: PropTypes.shape({
    periodo: PropTypes.arrayOf(PropTypes.object),
    handlePeriodo: PropTypes.func,
    produto: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleProduto: PropTypes.func,
    cidade: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleCidade: PropTypes.func,
    estado: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleEstado: PropTypes.func,
    medida: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    handleMedida: PropTypes.func,
  }).isRequired,
};

export default Filters;
